// dp-setup-8files.js
const FINAL_BTN_SELECTOR = '.final-download-btn';

(function(){
const PDF_MAP = {
  "sunday_overview_daily":   
    "https://www.dropbox.com/scl/fi/gynbu323xa92iup8whnkc/2026-Daily-Prophet-Planner-P01-Sunday-Overview-Daily.pdf?rlkey=fj92s206vlhfxoo1w2aio2cn5&st=nujr8ys4&dl=1",

  "sunday_overview_nodaily": 
    "https://www.dropbox.com/scl/fi/ji1v0gru3hqk40c13i1nr/2026-Daily-Prophet-Planner-P02-Sunday-Overview-NoDaily.pdf?rlkey=0lh7bpytetaj7a47pz3gxxoi3&st=hxd4ulkr&dl=1",

  "sunday_dashboard_daily":  
    "https://www.dropbox.com/scl/fi/uqah0po11tl2ndp1nkcvo/2026-Daily-Prophet-Planner-P03-Sunday-Dashboard-Daily.pdf?rlkey=v2kyfxoxk3edtn2gyotou002m&st=esz6o0w8&dl=1",

  "sunday_dashboard_nodaily":
    "https://www.dropbox.com/scl/fi/7zyf335ezkm8h7bgr6fb3/2026-Daily-Prophet-Planner-P04-Sunday-Dashboard-NoDaily.pdf?rlkey=15x894d1aa84enqq6a0b4ftor&st=gse3e2el&dl=1",

  "monday_overview_daily":   
    "https://www.dropbox.com/scl/fi/hzz5kyktik2lr2ewkos8p/2026-Daily-Prophet-Planner-P05-Monday-Overview-Daily.pdf?rlkey=387eplzrpd5kmgn5qyxn3vgs1&st=i7v5uxun&dl=1",

  "monday_overview_nodaily": 
    "https://www.dropbox.com/scl/fi/vj8j8mms176xy003f0s8m/2026-Daily-Prophet-Planner-P06-Monday-Overview-NoDaily.pdf?rlkey=8wvykzn8l5qc37py91wd67033&st=hwpnd2r3&dl=1",

  "monday_dashboard_daily":  
    "https://www.dropbox.com/scl/fi/9kxtiwl85r9g8ki2nuwlw/2026-Daily-Prophet-Planner-P07-Monday-Dashboard-Daily.pdf?rlkey=ow8v6nqt4a3vxbg56tdf9xlfa&st=s06nc0lz&dl=1",

  "monday_dashboard_nodaily":
    "https://www.dropbox.com/scl/fi/5fxj6991rwlybin0ilckz/2026-Daily-Prophet-Planner-P08-Monday-Dashboard-NoDaily.pdf?rlkey=o47x0fnavvikfl644lcyy9orl&st=996izfe5&dl=1"
};

  const selections = { step1:null, step2:null, step3:null, step4:null };

  function attachChoices(){
    const nodes = document.querySelectorAll('.choice-btn');
    if (!nodes || nodes.length === 0) return false;

    nodes.forEach(btn=>{
      if (btn.__dp_attached) return;
      btn.__dp_attached = true;

      btn.addEventListener('click', function(e){
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        const s = this.getAttribute('data-step');
        const v = this.getAttribute('data-value');
        if (!s) return false;

        selections['step' + s] = v || null;

        document.querySelectorAll('.choice-btn[data-step="'+s+'"]').forEach(x=>x.classList.remove('selected'));
        this.classList.add('selected');

        updateFinalButtonState();
        return false;
      }, { passive:false });
    });
    return true;
  }

  function updateFinalButtonState(){
    const btn = document.querySelector(FINAL_BTN_SELECTOR);
    if (!btn) return;
    const ready = selections.step2 && selections.step3 && selections.step4;
    btn.disabled = !ready;
    if (ready) btn.classList.add('ready'); else btn.classList.remove('ready');
  }

  async function fetchAndTriggerDownload(url){
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const filename = (url.split('/').pop()||'download.pdf').split('?')[0];
      const obj = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = obj; a.download = filename;
      document.body.appendChild(a); a.click(); a.remove();

      setTimeout(()=>URL.revokeObjectURL(obj),1500);
      return true;
    } catch(e){ return false; }
  }

  function fallbackLinkDownload(url){
    try {
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a); a.click(); a.remove();
      return true;
    } catch(e){ return false; }
  }

  function attachDownload(){
    const btn = document.querySelector(FINAL_BTN_SELECTOR);
    if (!btn) return false;
    if (btn.__dp_download) return true;
    btn.__dp_download = true;
    btn.disabled = true;

    btn.addEventListener('click', async function(e){
      if (e && e.preventDefault) e.preventDefault();
      if (e && e.stopPropagation) e.stopPropagation();

      if (!selections.step2 || !selections.step3 || !selections.step4){
        alert('Please complete all steps first.');
        return false;
      }

      const key = `${selections.step2}_${selections.step3}_${selections.step4}`.toLowerCase();
      const url = PDF_MAP[key];
      if (!url){
        alert('No PDF found for this selection.');
        return false;
      }

      if (await fetchAndTriggerDownload(url)) return false;
      if (fallbackLinkDownload(url)) return false;

      window.open(url, '_blank');
      return false;
    }, { passive:false });

    return true;
  }

  function waitAttach(retries=30, interval=300){
    let i=0;
    const id = setInterval(()=>{
      i++;
      const a = attachChoices();
      const b = attachDownload();
      if ((a && b) || i>=retries) clearInterval(id);
    }, interval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ()=> waitAttach());
  } else waitAttach();

  (function injectCSS(){
    const css = `
      .choice-btn.selected {
        outline: 3px solid rgba(120,170,255,0.9);
        border-radius:6px;
        background-color:#000 !important;
        color:#fff !important;
      }
      .final-download-btn.ready {
        box-shadow: 0 6px 18px rgba(0,0,0,0.15);
        transform: translateY(-1px);
      }
      .final-download-btn[disabled]{
        opacity:0.5;
        filter:grayscale(0.3);
        pointer-events:auto;
      }
    `;
    const s = document.createElement('style');
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  })();

})();